import React, { useMemo, useState } from 'react';
import { Alert } from 'reactstrap';
import { faChevronRight, faQuestionCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../../../../shared/contexts/AppContextProvider';
import { usePrefiterParams, useWindowWidth } from '../../../../../shared/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface PrefiltersResetProps {
    displayOnlyMobile: boolean;
}

const PrefiltersReset: React.FC<PrefiltersResetProps> = ({
    displayOnlyMobile,
}) => {
    const { t } = useTranslation();
    const { getAll, remove, clear } = usePrefiterParams();
    const { prefiltersData } = useAppContext();
    const { windowWidth } = useWindowWidth();
    const [expanded, setExpanded] = useState<boolean>(false);

    const prefiltersAllowRemoval = useMemo(() => {
        if (!prefiltersData) return [];
        return prefiltersData.filter(p => p.removable);
    }, [prefiltersData]);

    const appliedFilters = Object.entries(getAll()).filter(
        ([key, value]) => {
            return value != null;
        },
    );

    const shouldRender = () => {
        if (windowWidth > 768 && displayOnlyMobile) return false;
        if (!prefiltersData || Object.values(getAll()).every(v => v === null))
            return false;
        return appliedFilters.some(applied =>
            prefiltersAllowRemoval.find(p => p.name === applied[0]),
        );
    };

    const handleResetClick = () => {
        clear();
        window.location.reload();
    }

    const handleRemoveClick = (filterKey: 'id' | 'id_biblioteca' |  'tipo_obra' | 'id_colecao' | 'cr') => {
        remove(filterKey);
        window.location.reload();
    }

    const renderAppliedList = () => {
        return appliedFilters.filter(applied =>
            prefiltersAllowRemoval.find(p => p.name === applied[0]),
        ).map((filter) => {
            return (
                <li
                    className={`${
                        windowWidth > 768 ? 'w-50' : 'w-100'
                    } d-flex justify-content-between mb-2 preto70`}
                >
                    <div>
                        <FontAwesomeIcon
                            icon={faChevronRight as IconProp}
                            className="mr-3"
                        />
                        {t(`lblPrefilter-${filter[0]}`)}
                    </div>
                    <button
                        className="rad5 b-none bkzero vermelho hover hvermelho ml-2 s12"
                        title={t('Remover')}
                        onClick={() => handleRemoveClick(filter[0] as any)}
                    >
                        <FontAwesomeIcon icon={faTimes as IconProp} />
                    </button>
                </li>
            )
        })

    }

    if (!shouldRender()) return null;
    return (
        <Alert
            color="warning"
            className="w-100"
        >
            <p className="preto70 s16 f500 mb-0 link click" onClick={() => setExpanded(!expanded)}>
                <FontAwesomeIcon icon={faQuestionCircle as IconProp} className='mr-3'/>
                {t('NaoEncontrouOqueProcurava')}
            </p>
            {expanded && (
                <>
                    <hr className="mb-2 mt-1" />
                    <p className="s12 mb-2 preto70">
                        {t('AlertPrefiltrosMsg')}
                    </p>
                    <ul className="s12 mb-1 p-0">
                        {renderAppliedList()}
                    </ul>
                    <button className="btn-generic--segundo bkbranco" onClick={() => handleResetClick()}>
                        {t('BtnRestaurarCatalogo')}
                    </button>
                </>
            )}
        </Alert>
    );
};

export default PrefiltersReset;
